const brandsContract = {
  "active": [
    {
      "id": "jeff-vn",
      "timezone": "Asia/Ho_Chi_Minh",
      "googleSignIn": { "web": "jeff-web" },
      "canonicalDomain": "jeff-vn.com",
      "ownedDomains": ["jeff-vn.com", "dong-deals.com"],
      "health": { "jeff-vn.com": "https://www.jeff-vn.com/api/health", "dong-deals.com": "https://dong-deals.com/" },
      "inactiveDomains": ["jeff.vn"]
    },
    {
      "id": "dong247-com",
      "timezone": "Asia/Ho_Chi_Minh",
      "canonicalDomain": "dong247.com",
      "ownedDomains": ["dong247.com", "dong-247.com"],
      "health": { "dong247.com": "https://dong247.com/", "dong-247.com": "https://dong-247.com/" }
    },
    {
      "id": "moneydong-com",
      "canonicalDomain": "jeff-vn.com",
      "ownedDomains": ["moneydong.com"],
      "health": { "moneydong.com": "https://moneydong.com/" }
    },
    {
      "id": "loanonline-ph",
      "timezone": "Asia/Manila",
      "features": ["academy"],
      "locales": ["en"],
      "googleSignIn": { "web": "jeff-web" },
      "canonicalDomain": "loanonline.ph",
      "ownedDomains": ["loanonline.ph", "cnd.ph", "peroloan.ph"],
      "health": { "loanonline.ph": "https://www.loanonline.ph/api/health", "cnd.ph": null, "peroloan.ph": "https://peroloan.ph/" }
    },
    {
      "id": "paisa247-in",
      "timezone": "Asia/Kolkata",
      "features": ["academy"],
      "locales": ["en", "hi"],
      "googleSignIn": { "web": "paisa247", "mobile-app": "paisa247" },
      "canonicalDomain": "paisa247.in",
      "ownedDomains": ["paisa247.in"],
      "health": { "paisa247.in": "https://www.paisa247.in/api/health" }
    },
    {
      "id": "finmart-vn",
      "canonicalDomain": "finmart.vn",
      "ownedDomains": ["finmart.vn"],
      "health": { "finmart.vn": "https://www.finmart.vn/api/health" }
    },
    {
      "id": "finmercado-mx",
      "timezone": "America/Mexico_City",
      "features": ["academy"],
      "locales": ["es"],
      "googleSignIn": { "web": "finmercado", "mobile-app": "finmercado" },
      "canonicalDomain": "finmercado.mx",
      "ownedDomains": ["finmercado.mx"],
      "health": { "finmercado.mx": "https://www.finmercado.mx/api/health" }
    },
    {
      "id": "mercadopeso-mx",
      "canonicalDomain": "mercadopeso.mx",
      "ownedDomains": ["mercadopeso.mx"],
      "health": { "mercadopeso.mx": "https://www.mercadopeso.mx/api/health" }
    },
    {
      "id": "finmerkado-ph",
      "googleSignIn": { "web": "jeff-web" },
      "canonicalDomain": "finmerkado.ph",
      "ownedDomains": ["finmerkado.ph"],
      "health": { "finmerkado.ph": "https://www.finmerkado.ph/api/health" }
    },
    {
      "id": "finmercado-es",
      "canonicalDomain": "finmercado.es",
      "ownedDomains": ["finmercado.es"],
      "health": { "finmercado.es": "https://www.finmercado.es/api/health" }
    },
    {
      "id": "finmercado-co",
      "timezone": "America/Bogota",
      "canonicalDomain": "finmercado.co",
      "ownedDomains": ["finmercado.co"],
      "health": { "finmercado.co": "https://www.finmercado.co/api/health" }
    },
    {
      "id": "finmercado-pe",
      "canonicalDomain": "finmercado.pe",
      "ownedDomains": ["finmercado.pe"],
      "health": { "finmercado.pe": "https://www.finmercado.pe/api/health" }
    },
    {
      "id": "finmercado-com-br",
      "canonicalDomain": "finmercado.com.br",
      "ownedDomains": ["finmercado.com.br"],
      "health": { "finmercado.com.br": "https://www.finmercado.com.br/api/health" }
    },
    {
      "id": "luminaonline-ph",
      "canonicalDomain": "luminaonline.ph",
      "ownedDomains": ["luminaonline.ph"],
      "health": { "luminaonline.ph": "https://luminaonline.ph/" }
    },
    {
      "id": "finmart-my",
      "timezone": "Asia/Kuala_Lumpur",
      "features": ["academy"],
      "locales": ["en", "ms"],
      "canonicalDomain": "finmart.my",
      "ownedDomains": ["finmart.my"],
      "health": { "finmart.my": "https://www.finmart.my/api/health" }
    },
    {
      "id": "finmart-in",
      "timezone": "Asia/Kolkata",
      "locales": ["en", "hi"],
      "canonicalDomain": "finmart.in",
      "ownedDomains": ["finmart.in"],
      "health": { "finmart.in": "https://www.finmart.in/api/health" }
    }
  ],
  "inactive": [
    {
      "id": "asia-deals",
      "canonicalDomain": "jeff-vn.com",
      "mainBrandId": "jeff-vn",
      "ownedDomains": ["asia-deals.com"]
    },
    {
      "id": "vn-deals",
      "canonicalDomain": "jeff-vn.com",
      "mainBrandId": "jeff-vn",
      "ownedDomains": ["vn-deals.com"]
    },
    {
      "id": "scorecredit-vn",
      "canonicalDomain": "jeff-vn.com",
      "ownedDomains": ["scorecredit.vn"]
    },
    {
      "id": "jeff-lk",
      "canonicalDomain": "jeff.lk",
      "ownedDomains": []
    },
    {
      "id": "finmart-id",
      "canonicalDomain": "finmart.id",
      "ownedDomains": ["finmart.id"]
    },
    {
      "id": "peramart-ph",
      "canonicalDomain": "loanonline.ph",
      "ownedDomains": ["peramart.ph"]
    },
    {
      "id": "dineroexpres-mx",
      "canonicalDomain": "finmercado.mx",
      "ownedDomains": []
    }
  ]
} as const;

export default brandsContract;
